import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseDeliveryManage() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getParts = (myPC, callback, bool) => {
    MyAxios.get(`Admin_Logestic_DeliveryManage/parts`, {
      headers: {
        IsPage: bool,
        pageCondition: myPC,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOrdersByDeliveryDate = (
    myPC,
    DeliveryDate,
    DeliveryPart,
    callback,
    bool
  ) => {
    MyAxios.get(`Admin_Logestic_DeliveryManage`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({
          pageCondition: myPC,
          DeliveryDate: DeliveryDate,
          DeliveryPart: DeliveryPart,
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback();
      }
    });
  };

  const getPlatforms = (callback) => {
    MyAxios.get(`Admin_Logestic_DeliveryManage/platforms`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback();
      }
    });
  };

  const AddPlatform = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_DeliveryManage`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const CancelDeliveryOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_DeliveryManage/cancel`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getParts,
    getOrdersByDeliveryDate,
    getPlatforms,
    AddPlatform,
    CancelDeliveryOrder,
  };
}
